import { getUrlParam, getValue } from '@/libs/functions/getValue'
import React, { useEffect, useState } from 'react'
import { getLevelProduct } from '@/services/memberLevel'
import Layout from '@/libs/components/Layout'
import { onGotoGoodsDetail } from '@/libs/functions/tools'
import Price from '@/libs/components/Price'
import useCategorySet from '@/libs/hooks/useCategorySet'

import styles from './index.scss'

interface Detail {
  imageUrl: string
  levelCode: string
  name: string
  productInfos?: {
    virtuallyType: string
    listViewUrl: string
    categoryType: string
    exchangeType: number
    exchangePrice: number
    pointPrice: number
    exchangePriceSuffix: number
    proCode: string
    proDesc: string
    proName: string
  }[]
}

const index = () => {
  const { categorySetting } = useCategorySet('TENANT', getValue('tenantCode'))
  const id = getUrlParam('id') || ''
  const [detail, setDetail] = useState<Detail>()

  useEffect(() => {
    getLevelProduct({ id }).then((res) => {
      setDetail(res)
    })
  }, [id])

  return (
    <Layout title={detail?.name}>
      <div className={styles.header}>
        <img className={styles.image} src={detail?.imageUrl} />
        <div className={styles.mask}></div>
        <div className={styles.title}>{detail?.name}</div>
      </div>
      <div
        className={styles.list}
        style={{ '--primary-color': categorySetting?.base?.primaryColor }}
      >
        {detail?.productInfos?.map((good) => (
          <div
            className={styles.card}
            onClick={() =>
              onGotoGoodsDetail(
                good.virtuallyType || good.categoryType,
                good.proCode,
              )
            }
          >
            <img className={styles.image} src={good.listViewUrl} />
            <div className={styles.text}>
              <div className={styles.title}>{good.proName}</div>
              <div className={styles.desc}>{good.proDesc}</div>
              <div className={styles.price}>
                <Price
                  className={styles.plus}
                  exchangeType={good.exchangeType}
                  exchangePrice={good.exchangePrice}
                  pointPrice={good.pointPrice}
                  exchangePriceSuffix={good.exchangePriceSuffix}
                  hideZero
                />
              </div>
            </div>
          </div>
        ))}
        {!detail?.productInfos?.length && (
          <div className={styles.empty}>
            <img src="https://oss-images.dragonpass.com.cn/business-saas/platform/2025-03-20_143816/%E7%A9%BA%E7%8A%B6%E6%80%81-%E7%99%BD%E5%A4%A9%E6%A8%A1%E5%BC%8F%402x.png" />
            <div className={styles.text}>暂无商品</div>
          </div>
        )}
      </div>
    </Layout>
  )
}

export default index
